import ClinicalTableSearch from './ClinicalTableSearch';

export default ClinicalTableSearch;
